import makeStyles from '@mui/styles/makeStyles';
import { blueGrey } from '@mui/material/colors';

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: theme.palette.text.primary,
    textAlign: 'center',
    height: 45,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  listContainer: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    boxSizing: 'border-box',
  },
  highlightContainer: {
    backgroundColor: blueGrey[50],
    borderRadius: 6,
    transition: 'background-color 0.3s ease',
  },
  headerContainer: {
    width: '100%',
  },

  scrollableListContainer: {
    overflowY: 'auto',
    width: '100%',
  },
  systemContainer: {
    width: '100%',
  },
  footerContainer: {},
  dirButtonContainer: {
    flexDirection: 'column',
    margin: '4px 8px 0px',
    width: 100,
    alignItems: 'center',
    display: 'flex',

    '& p[type="label_medium"]': {
      textAlign: 'center',
      color: theme.colors.blue,
    },
  },

  topic: {
    padding: '6px 6px 6px 16px',
    breakInside: 'avoid',
  },

  topicFlex: {
    display: 'flex',
  },

  listItem: {
    borderTop: `${theme.palette.action.disabled} solid 1px`,
    position: 'relative',
  },
  marginLeft: {
    marginLeft: theme.spacing(2),
  },
  marginRight: {
    marginRight: theme.spacing(4),
  },
  tagContainer: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.primary,
  },
  tagActive: {
    color: theme.colors.blue,
  },
  checkpointText: {
    '& .MuiTypography-root': {
      fontSize: `14px !important`,
    },
  },
  shimmer: {
    position: 'relative',
    borderRadius: '50%',
    overflow: 'hidden',
    contain: 'layout paint',

    // Icon content stays above the shimmer band
    '& .MuiSvgIcon-root': {
      position: 'relative',
      zIndex: 1,
      color: theme.palette.common.white,
    },

    // White shimmer band over the blue fill, under the icon
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '60%',
      height: '100%',
      background: 'linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.65) 50%, rgba(255,255,255,0) 100%)',
      filter: 'blur(1px)',
      transform: 'translate3d(-180%, 0, 0)',
      willChange: 'transform',
      backfaceVisibility: 'hidden',
      pointerEvents: 'none',
      zIndex: 0,
      animation: '$shimmerTranslate 1.6s ease-in-out infinite, $stopShimmer 60s forwards',
    },
  },
  shimmerOff: {
    '&::before': { animation: 'none !important' },
  },

  '@keyframes shimmerTranslate': {
    '0%': { transform: 'translateX(-180%)' },
    '100%': { transform: 'translateX(180%)' },
  },
  '@keyframes stopShimmer': {
    to: { animation: 'none' },
  },

  '@media (prefers-reduced-motion: reduce)': {
    shimmer: { '&::before': { animation: 'none !important' } },
  },
}));

export default useStyles;
